// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from "react";

import { Stack, useMediaQuery, useTheme, Tab, Tabs, Autocomplete, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import BaseFilterTableWithAccordion from "../../atoms/BaseFilterTableWithAccordion";
import {
  GridColDef,
  GridActionsCellItem,
  GridRowId,
  GridRenderCellParams,
  GridPaginationModel,
} from "@mui/x-data-grid";
import { CommissionDetailModal, DeleteConfirmModal, DocumentDetailModal, Table, TerminalDetailModal, HashPasswordDialog, GetHashPasswordDialog, BlacklistModal, ActivateModal, IksQueryModal } from "../../molecules"; // Added IksQueryModal
import { IksOperationsModal } from "./IksOperationsModal";
import { Loading, Button, StatusBarUser, MerchantBulkPortfolioModal } from "../../atoms";
import {
  DeleteMerchantRequest,
  IMerchant,
  PagingResponse,
  useAddIks,
  useAuthorization,
  useGetBankList,
  useGetMerchantList,
  useGetMerchantStatusList,
  useGetMerchantTypeList,
  useGetPosTypeList,
  useMerchantDelete,
  useGetCityList,
  useGetMerchantUserPortfolioList,
  useGetMerchantStatusCounts,
  useApproveBlackListedMerchant,
  useGetVPosIntegrationStatusList,
  useGetMerchantCategoryList
} from "../../../hooks";
import { useLocation, useNavigate } from "react-router-dom";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { downloadExcel } from "../../../util/downloadExcel";
import { useUserInfo } from "../../../store/User.state";
import { createStatusOperator } from "../../molecules/StatusFilterComponents";
import dayjs from "dayjs";


function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;

  return <>{value && <StatusBarUser status={value} />}</>;
}

type MerchantListingTableProps = {
  onRowClick?: (data: { id: GridRowId; row: IMerchant }) => void;
};

export const MerchantListingTable = ({
  onRowClick,
}: MerchantListingTableProps) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const theme = useTheme();
  const { showDelete, showUpdate } = useAuthorization();
  const [userInfo] = useUserInfo();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const { data: rawPosTypes, isLoading: isPosTypeLoading } = useGetPosTypeList(
    {}
  );
  const { data: rawMerchantTypes, isLoading: isMerchantTypeLoading } =
    useGetMerchantTypeList({});
  const { data: rawCityList, isLoading: isCityListLoading } = useGetCityList({});
  const { data: rawUserPortfolioList, isLoading: isUserPortfolioListLoading } = useGetMerchantUserPortfolioList();
  const { data: rawVPosIntegrationStatus, isLoading: isVPosIntegrationStatusLoading } = useGetVPosIntegrationStatusList({});
  const [queryOptions, setQueryOptions] = React.useState({});
  const [tableData, setTableData] = useState<PagingResponse<Array<any>>>();
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 25,
  });
  const [isFilterAccordionExpanded, setFilterAccordionExpand] = useState(true);
  const [showTable, setShowTable] = useState(false)
  const navigate = useNavigate();
  const { mutate: getMerchantList, isLoading } = useGetMerchantList();
  const { mutate: addIks, isLoading: isAddingIks } = useAddIks();
  const setSnackbar = useSetSnackBar();
  const [shouldRefresh, setShouldRefresh] = React.useState(false);
  const [hashPasswordOpen, setHashPasswordOpen] = React.useState(false);
  const [getHashPasswordOpen, setGetHashPasswordOpen] = React.useState(false);
  const [blacklistModalOpen, setBlacklistModalOpen] = React.useState(false);
  const [selectedMerchantForBlacklist, setSelectedMerchantForBlacklist] = React.useState<{
    id: number;
    name: string;
  } | null>(null);
  const [activateModalOpen, setActivateModalOpen] = React.useState(false);
  const [selectedMerchantForActivation, setSelectedMerchantForActivation] = React.useState<{
    id: number;
    name: string;
  } | null>(null);
  const [portfolioNameFilter, setPortfolioNameFilter] = useState("");
  const [selectedCity, setSelectedCity] = useState<{ label: string; value: number } | null>(null);
  const [selectedPortfolio, setSelectedPortfolio] = useState<{ label: string; value: string } | null>(null);
  const [selectedVPosIntegrationStatus, setSelectedVPosIntegrationStatus] = useState<{ label: string; value: string } | null>(null);
  const [selectedLastTransactionBankBlocked, setSelectedLastTransactionBankBlocked] = useState<{ label: string; value: boolean } | null>(null);
  const [selectedMcc, setSelectedMcc] = useState<{ label: string; value: string } | null>(null);
  const [tabValue, setTabValue] = useState(0);
  const merchantStatusTypes = ["ACTIVE", "PASSIVE", "BLOCKED", "BLACKLISTED", "BLACKLISTPENDING"];

  const { mutate: approveBlackListedMerchant, isLoading: isApproveBlackListedMerchantLoading } = useApproveBlackListedMerchant();
  const { data: rawMccList, isLoading: isMccListLoading } = useGetMerchantCategoryList({
    page: 0,
    size: 1000,
    orderBy: "Description",
    status: "ACTIVE"
  });

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };
  const [startDate, setStartDate] = useState<dayjs.Dayjs | null>(null);
  const [endDate, setEndDate] = useState<dayjs.Dayjs | null>(null);

  const { data: rawMerchantStatus, isLoading: isMerchantStatusLoading } =
    useGetMerchantStatusList({});
  const posTypes = useMemo(() => {
    return rawPosTypes?.data?.map(
      (rawPosType: { key: string; value: string }) => {
        return {
          label: rawPosType.value,
          value: rawPosType.key,
        };
      }
    );
  }, [rawPosTypes?.data]);

  const merchantStatuses = useMemo(() => {
    return rawMerchantStatus?.data?.map(
      (merchantStat: { value: string; key: number }) => {
        return {
          label: merchantStat.key,
          value: `${merchantStat.value}`,
        };
      }
    );
  }, [rawMerchantStatus?.data]);

  const merchantTypes = useMemo(() => {
    return rawMerchantTypes?.data?.map(
      (merchantType: { value: string; key: number }) => {
        return {
          label: merchantType.value,
          value: `${merchantType.key}`,
        };
      }
    );
  }, [rawMerchantTypes?.data]);

  const vPosIntegrationStatusList = useMemo(() => {
    return rawVPosIntegrationStatus?.data?.map(
      (status: { value: string; key: number }) => {
        return {
          label: status.value,
          value: `${status.key}`,
        };
      }
    );
  }, [rawVPosIntegrationStatus?.data]);

  useEffect(() => {
    const savedFilter = localStorage.getItem("merchantListingTableFilter");
    if (savedFilter) {
      setQueryOptions(JSON.parse(savedFilter));
    }
  }, []);

  const cityOptions = useMemo(() => {
    return rawCityList?.data?.map(
      (city: { name: string; cityCode: string }) => ({
        label: `${city.name} (${city.cityCode})`,
        value: Number(city.cityCode),
      })
    ) || [];
  }, [rawCityList?.data]);

  const portfolioOptions = useMemo(() => {
    return rawUserPortfolioList?.data?.map(
      (user: { id: number; fullName: string; mail: string }) => ({
        label: `${user.fullName} (${user.mail})`,
        value: user.fullName,
      })
    ) || [];
  }, [rawUserPortfolioList?.data]);

  const mccOptions = useMemo(() => {
    return rawMccList?.data?.map((mcc: any) => ({
      label: `${mcc.code} - ${mcc.description}`,
      value: mcc.code
    })) || [];
  }, [rawMccList?.data]);

  useEffect(() => {
    if (selectedCity) {
      setQueryOptions(prev => ({ ...prev, cityCode: selectedCity.value }));
      localStorage.setItem('merchantListingTableFilter', JSON.stringify({ ...queryOptions, cityCode: selectedCity.value }));
    } else {
      const { cityCode, ...rest } = queryOptions;
      setQueryOptions(rest);
      localStorage.setItem('merchantListingTableFilter', JSON.stringify(rest));
    }
  }, [selectedCity]);

  useEffect(() => {
    if (selectedPortfolio) {
      setQueryOptions(prev => ({ ...prev, userPortfolioName: selectedPortfolio.value }));
      localStorage.setItem('merchantListingTableFilter', JSON.stringify({ ...queryOptions, userPortfolioName: selectedPortfolio.value }));
      setPortfolioNameFilter(selectedPortfolio.value);
    } else {
      const { userPortfolioName, ...rest } = queryOptions;
      setQueryOptions(rest);
      localStorage.setItem('merchantListingTableFilter', JSON.stringify(rest));
      setPortfolioNameFilter("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPortfolio]);
  useEffect(() => {
    if (selectedLastTransactionBankBlocked) {
      setQueryOptions(prev => ({ ...prev, lastTransactionBankBlocked: selectedLastTransactionBankBlocked.value }));
      localStorage.setItem('merchantListingTableFilter', JSON.stringify({ ...queryOptions, lastTransactionBankBlocked: selectedLastTransactionBankBlocked.value }));
    } else {
      const { lastTransactionBankBlocked, ...rest } = queryOptions;
      setQueryOptions(rest);
      localStorage.setItem('merchantListingTableFilter', JSON.stringify(rest));
    }
  }, [selectedLastTransactionBankBlocked]);

  useEffect(() => {
    if (selectedMcc) {
      setQueryOptions(prev => ({ ...prev, mcc: selectedMcc.value }));
      localStorage.setItem('merchantListingTableFilter', JSON.stringify({ ...queryOptions, mcc: selectedMcc.value }));
    } else {
      const { mcc, ...rest } = queryOptions;
      setQueryOptions(rest);
      localStorage.setItem('merchantListingTableFilter', JSON.stringify(rest));
    }
  }, [selectedMcc]);


  useEffect(() => {

    var orderByData = "CreateDate";

    if (tabValue === "BLACKLISTED" || tabValue === "BLACKLISTPENDING") {
      orderByData = "UpdateDate";
    }

    const filters = [];

    const requestPayload = {
      size: paginationModel.pageSize,
      page: paginationModel.page,
      orderBy: orderByData,
      orderByDesc: true,
      merchantId: userInfo ? Number(userInfo.merchantId) : undefined,
      merchantStatusType: merchantStatusTypes[tabValue],
      ...getQueryParams(queryOptions),
      filters: filters,
    };

    if (selectedPortfolio) {
      requestPayload.portfolioUserName = selectedPortfolio.value;
    }

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    if (selectedVPosIntegrationStatus) {
      requestPayload.vPosIntegrationStatus = selectedVPosIntegrationStatus.value;
    }

    if (selectedLastTransactionBankBlocked) {
      requestPayload.lastTransactionBankBlocked = selectedLastTransactionBankBlocked.value;
    }

    if (selectedMcc) {
      requestPayload.mcc = selectedMcc.value;
    }

    getMerchantList(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  }, [
    getMerchantList,
    paginationModel.page,
    paginationModel.pageSize,
    setSnackbar,
    queryOptions,
    shouldRefresh,
    tabValue,
    userInfo,
    selectedVPosIntegrationStatus,
  ]);

  const handleChangePagination = (model: GridPaginationModel) => {
    setPaginationModel(model);
    setTableData(undefined);

    const requestPayload = {
      size: model.pageSize,
      page: model.page,
      orderBy: "CreateDate",
      orderByDesc: true,
      merchantId: userInfo ? Number(userInfo.merchantId) : undefined,
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    getMerchantList(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            setTableData(data?.data);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const editRow = React.useCallback(
    (merchant: IMerchant) => () => {
      localStorage.removeItem("merchantData");
      navigate("/merchant-management/merchant-identification", {
        state: merchant,
      });
    },
    [navigate]
  );

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(0);
  const { mutate: merchantDelete, isLoading: isDeleteLoading } =
    useMerchantDelete();

  const deleteRow = React.useCallback(
    (merchant: IMerchant) => () => {
      setIsDeleteModalOpen(true);
      setSelectedRowId(Number(merchant.id));
    },
    []
  );

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteConfirm = () => {
    const deleteRequest: DeleteMerchantRequest = { id: selectedRowId };

    merchantDelete(deleteRequest, {
      onSuccess: (data: any) => {
        if (data.isSuccess) {
          setShouldRefresh(prev => !prev);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: data.message,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: () => {
        setSnackbar({
          severity: "error",
          description: "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      },
    });

    handleCloseDeleteModal();
  };

  const IksAddButton = ({ merchantId, addIks, disabled }) => {
    const handleIksAdd = () => {
      addIks(
        { merchantId: merchantId },
        {
          onSuccess: (data) => {
            if (data.isSuccess) {
              setSnackbar({
                severity: 'success',
                description: data.message || 'İşlem başarılı.',
                isOpen: true,
              });
              //Listeyi tekrar çekiyorum.
              setShouldRefresh(prev => !prev);
            } else {
              setSnackbar({
                severity: 'error',
                description: data.message,
                isOpen: true,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: 'error',
              description: 'İşlem sırasında bir hata oluştu.',
              isOpen: true,
            });
          },
        }
      );
    };

    return (
      <Button
        text="IKS'YE EKLE"
        variant="text"
        color="info"
        sx={{ flex: 1, height: 20, py: 5 }}
        disabled={disabled}
        onClick={handleIksAdd}>


      </Button>
    );
  };
  const useModal = () => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);

    return {
      isOpen,
      openModal,
      closeModal
    };
  };
  const [currentMerchantId, setCurrentMerchantId] = useState({
    terminal: null,
    document: null,
    commission: null,
    hashPassword: null,
    getHashPassword: null,
  });

  const terminalModal = useModal();
  const documentModal = useModal();
  const commissionModal = useModal();

  const { data: statusCountsData, refetch: refetchStatusCounts } = useGetMerchantStatusCounts();

  const handleApproveBlackListedMerchant = (pMerchantId) => {
    approveBlackListedMerchant({
      merchantId: pMerchantId
    }, {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setShouldRefresh(prev => !prev);
          refetchStatusCounts();
          setSnackbar({
            severity: "success",
            description: data.message || "İşlem başarılı.",
            isOpen: true,
          });
        } else {
          setSnackbar({
            severity: "error",
            description: data.message,
            isOpen: true,
          });
        }
      },
      onError: (error) => {
        setSnackbar({
          severity: "error",
          description: error.message || "İşlem sırasında bir hata oluştu",
          isOpen: true,
        });
      }
    })
  }

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: "Aksiyonlar",
        type: "actions",
        width: 80,
        getActions: (params) => {
          // if (params.row.status === 'PASSIVE' && params.row.annulmentCode !== "") {
          //   return [];
          // }

          const actions = [];

          if (showUpdate) {
            actions.push(
              <GridActionsCellItem
                label="Düzenle"
                onClick={editRow(params.row)}
                showInMenu
              />
            );
          }

          actions.push(
            <GridActionsCellItem
              label="Terminal"
              onClick={() => {
                setCurrentMerchantId(prev => ({ ...prev, terminal: params.row.merchantId }));
                terminalModal.openModal();
              }}
              showInMenu
            />
          );

          actions.push(
            <GridActionsCellItem
              label="IKS İşlemleri"
              onClick={() => {
                setSelectedMerchantForIks(params.row.merchantId);
                setIsIksModalOpen(true);
              }}
              showInMenu
            />
          );

          if (params.row.documents) {
            actions.push(
              <GridActionsCellItem
                label="Doküman"
                onClick={() => {
                  setCurrentMerchantId(prev => ({ ...prev, document: params.row.merchantId }));
                  documentModal.openModal();
                }}
                showInMenu
              />
            );
          }

          actions.push(
            <GridActionsCellItem
              label="Komisyon"
              onClick={() => {
                setCurrentMerchantId(prev => ({ ...prev, commission: params.row.merchantId }));
                commissionModal.openModal();
              }}
              showInMenu
            />
          );

          if (params.row.status === 'ACTIVE') {
            actions.push(
              <GridActionsCellItem
                label="Üye İşyeri Şifre"
                onClick={() => {
                  setCurrentMerchantId(prev => ({ ...prev, hashPassword: params.row.merchantId }));
                  setHashPasswordOpen(true);
                }}
                showInMenu
              />
            );
          }
          if (params.row.status === 'ACTIVE') {
            actions.push(
              <GridActionsCellItem
                label="Mevcut Üye İşyeri Şifre"
                onClick={() => {
                  setCurrentMerchantId(prev => ({ ...prev, getHashPassword: params.row.merchantId }));
                  setGetHashPasswordOpen(true);
                }}
                showInMenu
              />
            );
          }

          if (params.row.merchantStatusType === 'BLACKLISTED') {
            actions.push(
              <GridActionsCellItem
                label="Onayla"
                onClick={() => {
                  handleApproveBlackListedMerchant(params.row.merchantId);
                }}
                showInMenu
              />
            );
          }

          if (tabValue === 4) {
            if (params.row.merchantStatusType !== 'BLACKLISTED') {
              actions.push(
                <GridActionsCellItem
                  label="Kara Listeye Ekle"
                  onClick={() => {
                    setSelectedMerchantForBlacklist({
                      id: params.row.merchantId,
                      name: params.row.merchantName || params.row.tradeName || 'İşyeri'
                    });
                    setBlacklistModalOpen(true);
                  }}
                  showInMenu
                />
              );
            }

            if (params.row.merchantStatusType !== 'ACTIVE') {
              actions.push(
                <GridActionsCellItem
                  label="Aktif Şirketler Listesine Ekle"
                  onClick={() => {
                    setSelectedMerchantForActivation({
                      id: params.row.merchantId,
                      name: params.row.merchantName || params.row.tradeName || 'İşyeri'
                    });
                    setActivateModalOpen(true);
                  }}
                  showInMenu
                />
              );
            }
          }

          return actions;
        }
      }
      ,
      {
        field: "iksAddButton",
        headerName: "IKS Ekle",
        width: 150,
        renderCell: (params) => {
          const isDisabled = params.row.iksIsSuccess === true;
          return <IksAddButton merchantId={params.row.merchantId} addIks={addIks} disabled={isDisabled} />;
        },
      },
      { field: "bkmIdNo", headerName: "BKM ID", width: 200 },
      {
        field: "posTypes",
        headerName: "Pos Tipi",
        width: 200,
        renderCell: (params) => {
          const posTypesForItem = posTypes?.filter(pt => params.row[pt.value])
            .map(pt => pt.label);
          return posTypesForItem?.join(", ");
        }
      }
      ,
      { field: "merchantId", headerName: "İşyeri No", width: 200 },
      { field: "merchantName", headerName: "İşyeri Adı", width: 200 },
      { field: "tradeName", headerName: "İşyeri Ticari Adı", width: 200 },
      {
        field: "parentMerchantName",
        headerName: "Bağlı Olduğu İşyeri Adı",
        width: 350,
      },
      {
        field: "userPortfolioName",
        headerName: "Satış Portföy",
        width: 150,
      },
      {
        field: "commissionProfileCode",
        headerName: "Çalışma Grubu",
        width: 200,
      },
      { field: "walletNo", headerName: "Cüzdan No.", width: 200 },
      { field: "taxNumber", headerName: "Vergi Kimlik No.", width: 200 },
      { field: "taxOfficeName", headerName: "Vergi Dairesi", width: 300 },
      { field: "mcc", headerName: "MCC", width: 100 },
      { field: "originalMcc", headerName: "Original MCC", width: 120 },
      { field: "employeeCount", headerName: "Çalışan Sayısı", width: 150 },
      { field: "estimatedGiro", headerName: "Tahmini Ciro", width: 150 },
      { field: "blockedDay", headerName: "Bloke Günü", width: 100 },
      { field: "paymentBlockedDay", headerName: "Ödeme Bloke Günü", width: 100 },
      {
        field: "aggreementDate",
        headerName: "Sözleşme Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        }
      },
      {
        field: "systemDate",
        headerName: "Oluşturma Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        }
      },
      {
        field: "firstTransactionDateTime",
        headerName: "Üye İşyeri İlk İşlem Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        }
      },
      {
        field: "openingDate",
        headerName: "İşyeri Açılış Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        }
      },
      {

        field: "closedDate",
        headerName: "İşyeri Kapanış Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        }
      },
      {
        field: "updateDate",
        headerName: "Güncelleme Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        }
      },
      { field: "updateUserName", headerName: "Güncelleyen Kullanıcı", width: 300 },
      { field: "officialFullName", headerName: "İşyeri Sahibin Adı", width: 300 },
      {
        field: "officialBirthDate",
        headerName: "İşyeri Sahibin Doğum T.",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        }
      },
      { field: "webSite", headerName: "Web Sitesi", width: 300 },
      {
        field: "isInvoiceSendAsEmailEnabled", headerName: "CepPOS Ödeme Sonrası Email Gönderimi", width: 300, renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      { field: "invoiceEmail", headerName: "Fatura Email Adresi", width: 300 },
      {
        field: "try",
        headerName: "TRY",
        width: 200,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      {
        field: "usd",
        headerName: "USD",
        width: 200,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      {
        field: "eur",
        headerName: "EUR",
        width: 200,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      {
        renderCell: RenderStatus,
        field: "status",
        headerName: "İşyeri Durumu",
        width: 150,
        filterOperators: [createStatusOperator(merchantStatuses)],

      },
      {
        field: "vPosIntegrationStatus",
        headerName: "VPos Entegrasyon Durumu",
        width: 200,
        filterable: false,
        renderCell: (params) => {
          if (!params.value) return "";
          const status = vPosIntegrationStatusList?.find(s => s.value == params.value);
          return status ? status.label : "";
        }
      },
      {
        renderCell: RenderStatus,
        field: "merchantStatusType",
        headerName: "İşyeri Durum Tipi",
        width: 150,
        filterOperators: [createStatusOperator(merchantStatuses)],

      },
      { field: "passiveReason", headerName: "Pasife Alma Nedeni", width: 230 },
      {
        field: "isPayoutBlocked", headerName: "Ödeme Alma Blokeli mi?", width: 200,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      { field: "payoutBlockReason", headerName: "Ödeme Bloke Sebebi", width: 200 },
      {
        field: "lastTransactionBankBlocked", headerName: "Son İşlemi Blokeli", width: 200,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      {
        field: "lastBankBlockedDate",
        headerName: "Son Bloke Tarihi",
        width: 200,
        renderCell: (params) => {
          if (!params.value) return "";
          const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
          if (formattedDate === "Invalid Date") return "";
          return formattedDate;
        }
      },
      { field: "vbUye", headerName: "VB Üye", width: 180 },
      { field: "vbTerminal", headerName: "VB Terminal", width: 180 },
      {
        field: "vbiks", headerName: "IKS", width: 150,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      { field: "hbUye", headerName: "HB Üye", width: 180 },
      { field: "hbTerminal", headerName: "HB Terminal", width: 180 },
      {
        field: "hbiks", headerName: "IKS", width: 150,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      { field: "zbUye", headerName: "ZB Üye", width: 180 },
      { field: "zbTerminal", headerName: "ZB Terminal", width: 180 },
      {
        field: "zbiks", headerName: "IKS", width: 150,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      { field: "isBUye", headerName: "İşB Üye", width: 180 },
      { field: "isBTerminal", headerName: "İşB Terminal", width: 180 },
      {
        field: "isBIKS", headerName: "IKS", width: 150,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      { field: "dbUye", headerName: "DB Üye", width: 180 },
      { field: "dbTerminal", headerName: "DB Terminal", width: 180 },
      {
        field: "dbiks", headerName: "IKS", width: 150,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      { field: "ktUye", headerName: "KT Üye", width: 180 },
      { field: "ktTerminal", headerName: "KT Terminal", width: 180 },
      { field: "cityName", headerName: "Şehir", width: 180 },
      {
        field: "ktiks", headerName: " IKS", width: 150,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      {
        field: "isApiPasswordSend",
        headerName: "Şifre Gönderildi mi?",
        width: 180,
        renderCell: (params) => {
          if (params.value === null || params.value === undefined) return " ";
          return params.value ? "Evet" : "Hayır";
        }
      },
      {
        field: "erpCustomerCode",
        headerName: "ERP İşyeri Kodu",
        width: 180
      },
      // { field: "iban", headerName: "IBAN", width: 300 },

      // {
      //   field: "partnerOneFullName",
      //   headerName: "Ortak 1 Ad Soyad",
      //   width: 300,
      // },
      // {
      //   field: "partnerOneCitizenNumber",
      //   headerName: "Ortak 1 Kimlik No.",
      //   width: 200,
      // },
      // {
      //   field: "partnerOneMobilePhone",
      //   headerName: "Ortak 1 Cep Telefonu",
      //   width: 200,
      // },
      // {
      //   field: "partnerTwoFullName",
      //   headerName: "Ortak 2 Ad Soyad",
      //   width: 300,
      // },
      // {
      //   field: "partnerTwoCitizenNumber",
      //   headerName: "Ortak 2 Kimlik No.",
      //   width: 200,
      // },
      // {
      //   field: "partnerTwoMobilePhone",
      //   headerName: "Ortak 2 Cep Telefonu",
      //   width: 200,
      // },
    ];
  }, [deleteRow, editRow, showDelete, showUpdate, tabValue]);

  const keyMapping = {
    "status": "İşyeri Durumu",
  };

  const convertCurrencyCodeToCurrency = (code) => {
    switch (code) {
      case 949:
        return "TL";
      case 840:
        return "USD";
      case 978:
        return "EUR";
      default:
        return "";
    }
  };

  const onSave = () => {
    const requestPayload = {
      size: -1,
      page: 0,
      orderBy: "CreateDate",
      orderByDesc: true,
      merchantId: userInfo ? Number(userInfo.merchantId) : undefined,
      merchantStatusType: merchantStatusTypes[tabValue],
      ...getQueryParams(queryOptions),
    };

    if (queryOptions?.field && queryOptions?.value !== undefined) {
      requestPayload[queryOptions.field] = queryOptions.value;
    }

    if (selectedPortfolio) {
      requestPayload.portfolioUserName = selectedPortfolio.value;
    }

    getMerchantList(
      requestPayload,
      {
        onSuccess: (data) => {
          if (data.isSuccess) {
            function fieldValue(data) {
              return data.map((item) => {
                let posTypesForItem = posTypes
                  .filter(pt => item[pt.value])
                  .map(pt => pt.label);
                let posTypeStr = posTypesForItem.join(", ");
                let merchantTypeLabel = merchantTypes.find(mt => mt.value === `${item?.merchantType}`)?.label || '';
                return {
                  "IKS Ekle": item?.iksIsSuccess ? "Evet" : "Hayır",
                  "BKM ID": item?.bkmIdNo,
                  "İşyeri No": item?.merchantId,
                  "Bağlı Olduğu İşyeri Adı": item?.parentMerchantName,
                  "Satış Portföy": item?.userPortfolioName,
                  "Pos Tipi": posTypeStr,
                  "İşyeri Ticari Adı": item?.tradeName,
                  "İşyeri Adı": item?.merchantName,
                  "Çalışma Grubu": item?.commissionProfileCode,
                  "İşyeri Tipi": merchantTypeLabel,
                  "MCC": item?.mcc,
                  "Original MCC": item?.originalMcc,
                  "Çalışan Sayısı": item?.employeeCount,
                  "Tahmini Ciro": item?.estimatedGiro,
                  "Bloke Günü": item?.blockedDay,
                  "Ödeme Bloke Günü": item?.paymentBlockedDay,
                  "Cüzdan No": item?.walletNo,
                  "Kimkik Numarası": item?.citizenshipNumber,
                  "Vergi Numarası": item?.taxNumber,
                  "Vergi Dairesi": item?.taxOfficeName,
                  "Vergi Dairesi İli": item?.cityName,
                  "Sicil No": item?.tradeRegistrationNumber,
                  "İşyeri Açılış Tarihi": item?.openingDate,
                  "Ortak 1 Ad Soyad": item?.partnerOneFullName,
                  "Ortak 1 Kimlik No": item?.partnerOneCitizenNumber,
                  "Ortak 1 Telefon No": item?.partnerOneMobilePhone,
                  "Ortak 1 Doğum Tarihi": item?.partnerOneBirthDate ? dayjs(item.partnerOneBirthDate).format("DD.MM.YYYY") : "",
                  "Ortak 1 Hisse Oranı": item?.partnerOnePercent,
                  "Ortak 1 Tipi": item?.partnerOneType,

                  "Ortak 2 Ad Soyad": item?.partnerTwoFullName,
                  "Ortak 2 Kimlik No": item?.partnerTwoCitizenNumber,
                  "Ortak 2 Telefon No": item?.partnerTwoMobilePhone,
                  "Ortak 2 Doğum Tarihi": item?.partnerTwoBirthDate ? dayjs(item.partnerTwoBirthDate).format("DD.MM.YYYY") : "",
                  "Ortak 2 Hisse Oranı": item?.partnerTwoPercent,
                  "Ortak 2 Tipi": item?.partnerTwoType,

                  "Ortak 3 Ad Soyad": item?.partnerThreeFullName,
                  "Ortak 3 Kimlik No": item?.partnerThreeCitizenNumber,
                  "Ortak 3 Telefon No": item?.partnerThreeMobilePhone,
                  "Ortak 3 Doğum Tarihi": item?.partnerThreeBirthDate ? dayjs(item.partnerThreeBirthDate).format("DD.MM.YYYY") : "",
                  "Ortak 3 Hisse Oranı": item?.partnerThreePercent,
                  "Ortak 3 Tipi": item?.partnerThreeType,

                  "Ortak 4 Ad Soyad": item?.partnerFourFullName,
                  "Ortak 4 Kimlik No": item?.partnerFourCitizenNumber,
                  "Ortak 4 Telefon No": item?.partnerFourMobilePhone,
                  "Ortak 4 Doğum Tarihi": item?.partnerFourBirthDate ? dayjs(item.partnerFourBirthDate).format("DD.MM.YYYY") : "",
                  "Ortak 4 Hisse Oranı": item?.partnerFourPercent,
                  "Ortak 4 Tipi": item?.partnerFourType,

                  "Ortak 5 Ad Soyad": item?.partnerFiveFullName,
                  "Ortak 5 Kimlik No": item?.partnerFiveCitizenNumber,
                  "Ortak 5 Telefon No": item?.partnerFiveMobilePhone,
                  "Ortak 5 Doğum Tarihi": item?.partnerFiveBirthDate ? dayjs(item.partnerFiveBirthDate).format("DD.MM.YYYY") : "",
                  "Ortak 5 Hisse Oranı": item?.partnerFivePercent,
                  "Ortak 5 Tipi": item?.partnerFiveType,

                  "Yetkili Kişi Ad Soyad": item?.officialFullName,
                  "Yetkili Kişi Kimlik No": item?.officialCitizenNumber,
                  "Yetkili Kişi Telefon No": item?.officialMobilePhone,
                  "Yetkili Kişi Doğum Tarihi": item?.officialBirthDate ? dayjs(item.officialBirthDate).format("DD.MM.YYYY") : "",
                  "Şehir": item?.cityName,
                  "İlçe": item?.districtName,
                  "Adres": item?.addressLine1,
                  "Adres Satırı 2": item?.addressLine2,
                  "Posta Kodu": item?.zipCode,
                  "Cep Telefon Numarası": item?.mobilePhoneNumber,
                  "Sabit Telefon": item?.phoneNumber,
                  "E-Posta": item?.emailAddress1,
                  "2.E-Posta": item?.emailAddress2,
                  "Fax Numarası": item?.faxNumber,
                  "Web Sitesi": item?.webSite,
                  // "Para Birimi": item?.currencyCode === 949 ? "TRY" : (item?.currencyCode === 840 ? "USD" : (item?.currencyCode === 978 ? "EUR" : "")),
                  "Hesap-1": convertCurrencyCodeToCurrency(item?.currencyCode),
                  "IBAN-1": item?.iban,
                  "Banka Adı-1": item?.bankName,
                  "Hesap Sahibi-1": item?.accountOwner,

                  "Hesap-2": convertCurrencyCodeToCurrency(item?.currencyCode1),
                  "IBAN-2": item?.iban1,
                  "Banka Adı-2": item?.bankName1,
                  "Hesap Sahibi-2": item?.accountOwner1,

                  "Hesap-3": convertCurrencyCodeToCurrency(item?.currencyCode2),
                  "IBAN-3": item?.iban2,
                  "Banka Adı-3": item?.bankName2,
                  "Hesap Sahibi-3": item?.accountOwner2,
                  // "IBAN": item?.iban,
                  // "Banka Adı":item?.bankName,
                  // "Hesap Sahibi":item?.accountOwner,
                  "TRY": item?.try ? "Evet" : "Hayır",
                  "USD": item?.usd ? "Evet" : "Hayır",
                  "EUR": item?.eur ? "Evet" : "Hayır",
                  [keyMapping["status"]]: item?.status,
                  "İşyeri Durum Tipi ": item?.merchantStatusType,
                  "Pasife Alma Nedeni": item?.passiveReason,
                  "Oluşturma Tarihi": item?.systemDate,
                  "Üye İşyeri İlk İşlem Tarihi": item?.firstTransactionDateTime,
                  "Sözleşme Tarihi": item?.aggreementDate,
                  "İşyeri Kapanış Tarihi": item?.closedDate,
                  "Hosting Şirket TCKN/VKN": item?.hostingCompanyCitizenNumber,
                  "Fesih Nedeni": item?.annulmentCode,
                  "Fesih Personel Adı Soyadı": item?.annulmentStaff,
                  "VB Üye": item?.vbUye,
                  "VB Terminal": item?.vbTerminal,
                  "IKS": item?.vbiks,
                  "HB Üye": item?.hbUye,
                  "HB Terminal": item?.hbTerminal,
                  "IKS": item?.hbiks,
                  "ZB Üye": item?.zbUye,
                  "ZB Terminal": item?.zbTerminal,
                  "IKS": item?.zbiks,
                  "İşB Üye": item?.isBUye,
                  "İşB Terminal": item?.isBTerminal,
                  "IKS": item?.isBIKS,
                  "DB Üye": item?.dbUye,
                  "DB Terminal": item?.dbTerminal,
                  "IKS": item?.dbiks,
                  "KT Üye": item?.ktUye,
                  "KT Terminal": item?.ktTerminal,
                  "IKS": item?.ktiks,
                  "Güncelleme Tarihi": item?.updateDate,
                  "Güncelleyen Kullanıcı": item?.updateUserName,
                  "İşyeri Sahibin Adı": item?.officialFullName,
                  "İşyeri Sahibin Doğum T.": item?.officialBirthDate,
                  "CepPOS Ödeme Sonrası Email Gönderimi": item?.isInvoiceSendAsEmailEnabled ? "Evet" : "Hayır",
                  "Fatura Email Adresi": item?.invoiceEmail,
                  "Şehir": item?.cityName,
                  "Şifre Gönderildi mi": item?.isApiPasswordSend ? "Evet" : "Hayır",
                  "ERP İşyeri Kodu": item?.erpCustomerCode,
                };
              });
            }
            const refactoredData = fieldValue(data?.data?.result);
            downloadExcel(refactoredData || [], "Üye İşyeri Listesi", keyMapping);
          } else {
            setSnackbar({
              severity: "error",
              description: data.message,
              isOpen: true,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            description: "İşlem sırasında bir hata oluştu",
            isOpen: true,
          });
        },
      }
    );
  };

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(null, args);
      }, delay);
    };
  };

  const getQueryParams = (filters) => {
    const queryParams = {};

    for (let key in filters) {
      if (filters[key]?.toString()?.length >= 1) {
        queryParams[key] = filters[key];
      }
    }

    return queryParams;
  };

  const handleFilterChange = debounce((filters) => {
    if (filters.clearFilter) {
      localStorage.removeItem('merchantListingTableFilter')
      return setQueryOptions({});
    }

    const queryParams = getQueryParams(filters);
    const allValuesAtLeastThreeChars = Object.values(queryParams).every((value) => value?.toString().length >= 3);
    const atLeastOneValueThreeChars = Object.values(queryParams).some((value) => value?.toString().length >= 3);

    const previousKeysLength = Object.keys(previousQueryParams.current).length;
    const currentKeysLength = Object.keys(queryParams).length;

    // Eğer queryParams bir önceki ile aynıysa işlem yapma
    if (JSON.stringify(previousQueryParams.current) === JSON.stringify(queryParams)) {
      return;
    }

    if ((allValuesAtLeastThreeChars || (atLeastOneValueThreeChars && previousKeysLength > currentKeysLength))) {
      setQueryOptions(queryParams);
      localStorage.setItem('merchantListingTableFilter', JSON.stringify(queryParams))
    }

    // userPortfolioName filtre değerini ayrıca sakla
    if (filters.userPortfolioName) {
      setPortfolioNameFilter(filters.userPortfolioName);
    } else {
      setPortfolioNameFilter("");
    }

    // Son olarak, mevcut queryParams değerini bir önceki değer olarak set edin
    previousQueryParams.current = queryParams;

  }, 500);

  const hasActiveFilters = Object?.keys(queryOptions)?.length > 0;
  // Komponent içerisinde
  const previousQueryParams = React.useRef({});

  const [selectedRows, setSelectedRows] = useState([]);

  const handleEmptySelectedRows = () => {
    setSelectedRows([]);
    setTableData(null);
    setShouldRefresh((prev) => !prev);
  }

  const [open, setOpen] = useState(false);

  const hasLoading = isLoading || isDeleteLoading || isAddingIks || isPosTypeLoading || isCityListLoading || isUserPortfolioListLoading;

  const handleDateFilter = () => {
    const newQueryOptions = { ...queryOptions };

    if (startDate) {
      newQueryOptions.systemDateStart = startDate.format('YYYY-MM-DD');
    } else {
      delete newQueryOptions.systemDateStart;
    }

    if (endDate) {
      newQueryOptions.systemDateEnd = endDate.format('YYYY-MM-DD');
    } else {
      delete newQueryOptions.systemDateEnd;
    }

    setQueryOptions(newQueryOptions);
    localStorage.setItem('merchantListingTableFilter', JSON.stringify(newQueryOptions));
  };

  const [selectedRowsRequest, setSelectedRowsRequest] = useState<any>(null);
  const [isIksModalOpen, setIsIksModalOpen] = useState(false);
  const [selectedMerchantForIks, setSelectedMerchantForIks] = useState<number | null>(null);
  const [isIksQueryModalOpen, setIsIksQueryModalOpen] = useState(false);
  const [selectedIksQueryReference, setSelectedIksQueryReference] = useState<string | undefined>(undefined);
  const [isQueryFromOperations, setIsQueryFromOperations] = useState(false);

  const handleOpenIksQuery = (referenceCode: string) => {
    setSelectedIksQueryReference(referenceCode);
    setIsQueryFromOperations(true);
    setIsIksModalOpen(false); // Close operations modal
    setIsIksQueryModalOpen(true); // Open query modal
  };

  const handleBackToOperations = () => {
    setIsIksQueryModalOpen(false);
    setIsIksModalOpen(true);
  };

  return (

    <>
      <IksOperationsModal
        isOpen={isIksModalOpen}
        onClose={() => { setIsIksModalOpen(false); setSelectedMerchantForIks(null); }}
        merchantId={selectedMerchantForIks}
        onOpenIksQuery={handleOpenIksQuery}
      />
      <IksQueryModal
        isOpen={isIksQueryModalOpen}
        onClose={() => {
          setIsIksQueryModalOpen(false);
          setSelectedIksQueryReference(undefined);
        }}
        initialReferenceCode={selectedIksQueryReference}
        onBack={isQueryFromOperations ? handleBackToOperations : undefined}
      />
      <MerchantBulkPortfolioModal open={open} setOpen={setOpen} selectedRows={selectedRows} setSelectedRows={handleEmptySelectedRows} currentRequest={selectedRowsRequest} />
      <TerminalDetailModal
        merchantId={currentMerchantId.terminal}
        isOpen={terminalModal.isOpen}
        handleClose={terminalModal.closeModal}
      />
      <DocumentDetailModal
        merchantId={currentMerchantId.document}
        isOpen={documentModal.isOpen}
        handleClose={documentModal.closeModal}
      />
      <CommissionDetailModal
        merchantId={currentMerchantId.commission}
        isOpen={commissionModal.isOpen}
        handleClose={commissionModal.closeModal}
      />

      <HashPasswordDialog
        merchantId={currentMerchantId.hashPassword}
        hashPasswordOpen={hashPasswordOpen}
        setHashPasswordOpen={setHashPasswordOpen}
        shouldRefresh={shouldRefresh}
        setShouldRefresh={setShouldRefresh}
      />
      <GetHashPasswordDialog
        merchantId={currentMerchantId.getHashPassword}
        getHashPasswordOpen={getHashPasswordOpen}
        setGetHashPasswordOpen={setGetHashPasswordOpen}
        shouldRefresh={shouldRefresh}
        setShouldRefresh={setShouldRefresh} />
      <BlacklistModal
        isOpen={blacklistModalOpen}
        onClose={() => {
          setBlacklistModalOpen(false);
          setSelectedMerchantForBlacklist(null);
        }}
        merchantId={selectedMerchantForBlacklist?.id || null}
        merchantName={selectedMerchantForBlacklist?.name}
        onSuccess={() => {
          setShouldRefresh(prev => !prev);
          refetchStatusCounts();
        }}
      />
      <ActivateModal
        isOpen={activateModalOpen}
        onClose={() => {
          setActivateModalOpen(false);
          setSelectedMerchantForActivation(null);
        }}
        merchantId={selectedMerchantForActivation?.id || null}
        merchantName={selectedMerchantForActivation?.name}
        onSuccess={() => {
          setShouldRefresh(prev => !prev);
          refetchStatusCounts();
        }}
      />
      {hasLoading && <Loading />}
      <Stack flex={1} p={2} >
        <BaseFilterTableWithAccordion
          summary="Filtreler"
          isExpanded={isFilterAccordionExpanded}
          setExpanded={setFilterAccordionExpand}
          setTableVisibility={setShowTable}
          child={
            <Stack sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Stack sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                  <Autocomplete
                    id="cityCode"
                    options={cityOptions}
                    value={selectedCity}
                    onChange={(_, value) => setSelectedCity(value)}
                    getOptionLabel={(option) => option.label ?? ""}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    renderInput={(params) => (
                      <TextField {...params} label="Şehir Seçiniz (Plaka Kodu ile)" placeholder="Şehir seçiniz" />
                    )}
                    sx={{ width: 300, mb: 2 }}
                  />
                  <Autocomplete
                    id="userPortfolioName"
                    options={portfolioOptions}
                    value={selectedPortfolio}
                    onChange={(_, value) => setSelectedPortfolio(value)}
                    getOptionLabel={(option) => option.label ?? ""}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    renderInput={(params) => (
                      <TextField {...params} label="Satış Portföyü Seçiniz" placeholder="Satış Portföyü seçiniz" />
                    )}
                    sx={{ width: 300, mb: 2 }}
                  />
                  <Autocomplete
                    id="vPosIntegrationStatus"
                    options={vPosIntegrationStatusList || []}
                    value={selectedVPosIntegrationStatus}
                    onChange={(_, value) => setSelectedVPosIntegrationStatus(value)}
                    getOptionLabel={(option) => option.label ?? ""}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    renderInput={(params) => (
                      <TextField {...params} label="VPos Entegrasyon Durumu" placeholder="VPos Entegrasyon Durumu seçiniz" />
                    )}
                    sx={{ width: 300, mb: 2 }}
                  />

                  <Autocomplete
                    id="lastTransactionBankBlocked"
                    options={[{ label: "Evet", value: true }, { label: "Hayır", value: false }]}
                    value={selectedLastTransactionBankBlocked}
                    onChange={(_, value) => setSelectedLastTransactionBankBlocked(value)}
                    getOptionLabel={(option) => option.label ?? ""}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    renderInput={(params) => (
                      <TextField {...params} label="Son İşlemi Blokeli" placeholder="Seçiniz" />
                    )}
                    sx={{ width: 300, mb: 2 }}
                  />
                  <Autocomplete
                    id="mcc"
                    options={mccOptions}
                    value={selectedMcc}
                    onChange={(_, value) => setSelectedMcc(value)}
                    getOptionLabel={(option) => option.label ?? ""}
                    isOptionEqualToValue={(option, value) => option.value === value.value}
                    renderInput={(params) => (
                      <TextField {...params} label="MCC Seçiniz" placeholder="MCC seçiniz" />
                    )}
                    sx={{ width: 300, mb: 2 }}
                  />
                  <DatePicker
                    label="İşyeri Oluşturma Başlangıç Tarihi"
                    value={startDate}
                    format="DD.MM.YYYY"
                    onChange={(newValue) => setStartDate(newValue)}
                    renderInput={(params) => <TextField {...params} />}
                    sx={{ width: 300, mb: 2 }}
                  />
                  <DatePicker
                    label="İşyeri Oluşturma Bitiş Tarihi"
                    value={endDate}
                    format="DD.MM.YYYY"
                    onChange={(newValue) => setEndDate(newValue)}
                    renderInput={(params) => <TextField {...params} />}
                    sx={{ width: 300, mb: 2 }}
                  />
                  <Button
                    onClick={handleDateFilter}
                    size="small"
                    variant="contained"
                    text="Şirket Listele"
                    sx={{ mb: 2, height: 40 }}
                  />
                  <Button
                    onClick={() => {
                      setIsQueryFromOperations(false);
                      setIsIksQueryModalOpen(true);
                    }}
                    size="small"
                    variant="contained"
                    text="IKS Sorgulama"
                    sx={{ mb: 2, height: 40, ml: 2 }}
                  />
                </Stack>
              </LocalizationProvider>
            </Stack>
          }
        />
        <>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            sx={{ mb: 2 }}
            centered
          >
            <Tab label={`Aktif (${statusCountsData?.data?.activeCount ?? 0})`} />
            <Tab label={`Pasif (${statusCountsData?.data?.passiveCount ?? 0})`} />
            <Tab label={`Bloke (${statusCountsData?.data?.blockedCount ?? 0})`} />
            <Tab label={`Kara Liste (${statusCountsData?.data?.blackListedCount ?? 0})`} />
            <Tab label={`Kara Liste Onayı Bekleyen (${statusCountsData?.data?.blackListPendintCount ?? 0})`} />
          </Tabs>
          <Table
            columnVisibilityConfigKey="merchantListingTableColumnVisibilityKey"
            filterKey="merchantListingTableFilter"
            handleFilterChange={handleFilterChange}
            hasActiveFilters={hasActiveFilters}
            paginationModel={paginationModel}
            onPaginationModelChange={handleChangePagination}
            paginationMode="server"
            rowCount={tableData?.totalItems || 0}
            sx={{ width: isDesktop ? 1308 : window.innerWidth - 50 }}
            onRowClick={onRowClick}
            // isRowSelectable={() => true}
            onRowSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              // If all rows are selected
              if (ids.length === tableData?.result.length) {
                // Save the request parameters
                const requestPayload = {
                  size: -1,
                  page: 0,
                  orderBy: "CreateDate",
                  orderByDesc: true,
                  merchantId: userInfo ? Number(userInfo.merchantId) : undefined,
                  merchantStatusType: merchantStatusTypes[tabValue],
                  ...getQueryParams(queryOptions),
                };

                if (queryOptions?.field && queryOptions?.value !== undefined) {
                  requestPayload[queryOptions.field] = queryOptions.value;
                }

                if (selectedPortfolio) {
                  requestPayload.portfolioUserName = selectedPortfolio.value;
                }

                setSelectedRowsRequest(requestPayload);
                const newSelectedRows = tableData?.result.filter((row) =>
                  selectedIDs.has(row.id)
                );
                setSelectedRows(newSelectedRows);
              } else {
                // Normal selection
                setSelectedRowsRequest(null);
                const newSelectedRows = tableData?.result.filter((row) =>
                  selectedIDs.has(row.id)
                );
                setSelectedRows(newSelectedRows);
              }
            }}
            selectedRows={selectedRows}
            // disableColumnMenu
            showMerchantBulkPortolioButton={true}
            checkboxSelection
            openDialog={() => setOpen(true)}
            disableRowSelectionOnClick
            rows={tableData?.result ?? []}
            columns={columns}
            exportFileName="Üye İşyeri Listesi"
            onSave={() => onSave()}
            getRowClassName={(params) => {
              if (params.row.status === 'PASSIVE') return 'blocked-row';
              if (params.row.status === 'BLOCKED') return 'pasive-row';
              return '';
            }}
          />

          <DeleteConfirmModal
            isOpen={isDeleteModalOpen}
            onClose={handleCloseDeleteModal}
            onConfirm={() => handleDeleteConfirm()}
          ></DeleteConfirmModal>
        </>

      </Stack>
    </>
  );
};
